// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Xq1BaYKEPEUYMrf4Qr2W{display:inline-flex;margin-top:36px;margin-bottom:10px}`, "",{"version":3,"sources":["webpack://./src/shared/ui/Modal/ui/ModalInfoBlockWithTitle/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,mBAAA,CACA,eAAA,CACA,kBAAA","sourcesContent":[".title {\n  display: inline-flex;\n  margin-top: 36px;\n  margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `Xq1BaYKEPEUYMrf4Qr2W`
};
export default ___CSS_LOADER_EXPORT___;
